import type { FaireProductEntity } from "../../entity_types/product";

export const p_sbpaa8fux3: FaireProductEntity = {
  token: "p_sbpaa8fux3",
  type: "product",
  name: "It's All About The Base White Red Baseball Snap Bracelet",
  brandToken: "b_aogprgmpxh",
  brandName: "GRACE+EMMA by Southern Grace",
  imageUrl:
    "https://cdn.faire.com/fastly/4fd4dd9cd67e6566b8b12caafd79cbd81fbf92759f1327b5f0b54e1823a05075.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c3ea979da6d9118316744aca528e3af4d5b771133baddc84be880fba14989cb.webp",
    "https://cdn.faire.com/fastly/e3eeea76ef6531c8aeacdcfd76e8958212bffc395683262eec6566ba77c9d4bb.webp",
    "https://cdn.faire.com/fastly/0dcb13da2438304091288176759818b85d57a4bef3d51366193e2d35ea64c7a8.webp",
  ],
  priceDollars: 2.77,
  description:
    'Show your love for the game with our Baseball Stitching Bracelet, available in white and yellow. \n\nDetails:\n\nBaseball White Bracelet  \nApprox. 2" in Length\nBaseball Stich \nFaux Leather\nMaterial and Care:\n\nMan Made Materials\nMaterial may have natural variations\nManufactured Overseas',
  tags: [],
  msrpDollars: 6.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:22.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
